import { createContext } from 'react';

const LastLocationContext = createContext(null);

export default LastLocationContext;